export function formatDate(timestamp) {
    const date = new Date(timestamp);

    const day = String(date.getDate()).padStart(2, '0'); // dd
    const month = String(date.getMonth() + 1).padStart(2, '0'); // mm
    const hours = String(date.getHours()).padStart(2, '0'); // 24h
    const minutes = String(date.getMinutes()).padStart(2, '0'); // mm
    const seconds = String(date.getSeconds()).padStart(2, '0'); // ss

    return `${day}/${month} ${hours}:${minutes}:${seconds}`;
}

export function formatRelativeTime(timestamp) {
    const now = Date.now(); // Timestamp atual
    const difference = Math.floor((now - timestamp) / 1000); // Diferença em segundos

    // Caso seja dentro de limite de 59 minutos
    if (difference < 60) {
        return `${difference} sec ago`;
    } else if (difference < 3600) {
        const minutes = Math.floor(difference / 60); // Converte para minutos
        return `${minutes} min ago`;
    } else {
        // Após 59 minutos, mostrar o horário completo
        return formatDate(timestamp); // Utiliza a função `formatDate` que criamos antes
    }
}

export function pct(v) {
  return `${Math.round(v * 100)}%`;
}

export function sum(v1, v2) {
  return v1 + v2;
}

export function multiply(v1, v2) {
  return v1 * v2;
}

export const formatCurrencyUSD = (val) => {
  return val != null ? `$${val.toFixed(2)}` : '$0';
};

export const formatPercentValues = (val) => {
  return val != null ? `${val.toFixed(2)}%` : '0%';
};

export function calcSpreadPercent(buyPrice, sellPrice){
  const spreadPercentual = ((sellPrice - buyPrice) / buyPrice) * 100;
  return spreadPercentual.toFixed(2)
}

export function calcPL(currentPrice, originPrice, totalQty){
  return ((currentPrice - originPrice) * totalQty)
}

export function computeWeightedNetPnl({
  longsQty = 0,
  longsNotional = 0,
  shortsQty = 0,
  shortsNotional = 0,
  markPrice = 0,
} = {}) {
  const longsAvg = longsQty > 0 ? longsNotional / longsQty : 0
  const shortsAvg = shortsQty > 0 ? shortsNotional / shortsQty : 0
  const totalLongPnL = longsQty * (markPrice - longsAvg)
  const totalShortPnL = shortsQty * (shortsAvg - markPrice)
  return {
    longsAvg,
    shortsAvg,
    totalLongPnL,
    totalShortPnL,
    totalNetPnl: totalLongPnL + totalShortPnL,
  }
}

export function calcManualsNetPnl(metrics) {
  const snapshot = metrics?.manualsSnapshot || {};
  const currentPrice = metrics?.currentPrice || 0;

  const shortsList = [
    ...(snapshot.spotShorts || []),
    ...(snapshot.futuresShorts || []),
  ].map((s) => ({ price: Number(s.p), qty: Number(s.q) }));

  const longsList = [
    ...(snapshot.spotLongs || []),
    ...(snapshot.futuresLongs || []),
  ].map((l) => ({ price: Number(l.p), qty: Number(l.q) }));

  const shortsQty = shortsList.reduce((acc, s) => acc + s.qty, 0);
  const shortsNotional = shortsList.reduce((acc, s) => acc + (s.qty * s.price), 0);
  const longsQty = longsList.reduce((acc, l) => acc + l.qty, 0);
  const longsNotional = longsList.reduce((acc, l) => acc + (l.qty * l.price), 0);

  return computeWeightedNetPnl({
    longsQty,
    longsNotional,
    shortsQty,
    shortsNotional,
    markPrice: currentPrice,
  }).totalNetPnl;
}

export function formatDateOnInputsForm(date) { // Formatar data para o formato YYYY-MM-DD (compatível com input[type="date"])
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
